import { SettingsCogIcon } from "@volt_developers/components";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  COMMON_TRANSLATION_KEYS,
  getFromCommonTranslationKeys,
} from "constants/commonTranslationsKeys";
import { COMMON_BREADCRUMBS_IDS } from "modules/common";

import { BREADCRUMBS_IDS } from "../../constants/BreadcrumbsIds";
import { PAGE_URLS } from "../../constants/PageUrls";
import { TEST_IDS } from "../../constants/TestIds";
import { TRANSLATION_KEYS } from "../../constants/TranslationKeys";

import type { BreadcrumbItem } from "modules/common";

export function useListBreadcrumbs() {
  const { t } = useTranslation("customers");

  return useMemo(
    (): BreadcrumbItem[] => [
      {
        id: COMMON_BREADCRUMBS_IDS.configuration,
        title: t(
          getFromCommonTranslationKeys(COMMON_TRANSLATION_KEYS.configuration)
        ),
        "data-testid": TEST_IDS.breadcrumbConfiguration,
        icon: <SettingsCogIcon />,
      },
      {
        id: BREADCRUMBS_IDS.list,
        title: t(TRANSLATION_KEYS.customers),
        url: PAGE_URLS.list,
        "data-testid": TEST_IDS.breadcrumbList,
      },
    ],
    [t]
  );
}
